import { apiGetAuth, apiPostAuth } from '@/utils/api'
import { API_INVOICE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  invoice_list: { 
    isLoading: false,
    data: false  
  },
  detail_invoice: {
    isLoading: false,
    data: false  
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  meta_filter_adhoc: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_INVOICE_LIST": (state, payload) => {
    state.invoice_list = payload
  },
  "SET_DETAIL_INVOICE": (state, payload) => {
    state.detail_invoice = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  "SET_META_FILTER_ADHOC": (state, payload) => {
    state.meta_filter_adhoc = payload
  }
}

const actions = {
  async getInvoiceList(context, payload) {
    try {
      context.commit('SET_INVOICE_LIST', { isLoading: true })
      const response = await apiGetAuth(API_INVOICE.LIST, payload)
      context.commit('SET_INVOICE_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch (err) {
      context.commit('SET_INVOICE_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailInvoice(context, payload) {
    try {
      context.commit('SET_DETAIL_INVOICE', { isLoading: true })
      const response = await apiGetAuth(API_INVOICE.BY_ID(payload))
      context.commit('SET_DETAIL_INVOICE', {
        isLoading: false,
        data: response.data.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_INVOICE', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async createInvoice(context, payload) {
    try {
      const response = await apiPostAuth(API_INVOICE.CREATE_INVOICE, payload)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  },
  async createInvoiceAdhoc(context, payload) {
    try {
      const response = await apiPostAuth(API_INVOICE.CREATE_INVOICE_ADHOC, payload)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  }
}

const getters = {
  get_invoice_list: state => {
    return state.invoice_list
  },
  get_detail_invoice: state => {
    return state.detail_invoice
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  },
  meta_filter_adhoc: state => {
    return state.meta_filter_adhoc
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
